var _path, _rect, _line, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMounttypeWall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "700px",
    height: "755.3px",
    viewBox: "0 0 700 755.3",
    enableBackground: "new 0 0 700 755.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M478.3,529c0,0,5.2,7.3,13.2,7.3s13.2-6.8,13.2-6.8s3.5-2.9,8.1-0.5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.4,
    fill: "#EDEDED",
    width: 700,
    height: 755.3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 2.9967,
    x1: 701,
    y1: 720.5,
    x2: 1,
    y2: 720.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 209.9,
    y: 123,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 3,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 146.1,
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    width: 234,
    height: 342.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 47.6,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.8553,
    width: 545,
    height: 11.4
  })), /*#__PURE__*/React.createElement("rect", {
    x: 46.4,
    y: 42.8,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.4992,
    width: 31.8,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.8,
    y: 42.8,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.4992,
    width: 31.8,
    height: 21
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9543,
    strokeMiterlimit: 10,
    d: "M219.6,726.1c0,0-7.7,8.2-15.6,8.3 c-7.9,0.1-14.6-7.3-14.6-7.3V63.5c0,0,4.9,0,15.1,0c10.2,0,15.1,0,15.1,0V726.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9536,
    strokeMiterlimit: 10,
    d: "M189.4,727.1c-4.6-2.4-8.1,0.5-8.1,0.5 s-5.3,6.8-13.3,6.8s-13.2-7.3-13.2-7.3V63.5h34.6V727.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9536,
    strokeMiterlimit: 10,
    d: "M154.8,727.1c-4.6-2.4-8.1,0.5-8.1,0.5 s-5.3,6.8-13.3,6.8c-8,0-13.2-7.3-13.2-7.3V63.5h34.6V727.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9536,
    strokeMiterlimit: 10,
    d: "M120.2,727.1c-4.6-2.4-8.1,0.5-8.1,0.5 s-5.3,6.8-13.3,6.8s-13.2-7.3-13.2-7.3V63.5h34.6V727.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9543,
    strokeMiterlimit: 10,
    d: "M479.8,726.1c0,0,7.7,8.2,15.6,8.3 c7.9,0.1,14.6-7.3,14.6-7.3V63.5c0,0-4.9,0-15.1,0c-10.2,0-15.1,0-15.1,0V726.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9536,
    strokeMiterlimit: 10,
    d: "M510,727.1c4.6-2.4,8.1,0.5,8.1,0.5 s5.3,6.8,13.3,6.8s13.2-7.3,13.2-7.3V63.5H510V727.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9536,
    strokeMiterlimit: 10,
    d: "M544.6,727.1c4.6-2.4,8.1,0.5,8.1,0.5 s5.3,6.8,13.3,6.8s13.2-7.3,13.2-7.3V63.5h-34.6V727.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9536,
    strokeMiterlimit: 10,
    d: "M579.2,727.1c4.6-2.4,8.1,0.5,8.1,0.5 s5.3,6.8,13.3,6.8s13.2-7.3,13.2-7.3V63.5h-34.6V727.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMounttypeWall);
export default __webpack_public_path__ + "static/media/mounttype-wall.30d8ed47c594d1f6c0c4d4f6c89de3f1.svg";
export { ForwardRef as ReactComponent };